import moment, { MomentInput } from "moment";
import { trainerContextStore } from "../../context/trainerContext/TrainerContextProvider";

export const getTrainerId = () => {
  const data = localStorage.getItem("trainerData");
  if (data) {
    const parsedData = JSON.parse(data);
    return parsedData?.trainerId || "nutrition-panel";
  }
  return "nutrition-panel";
};

export const convertObjToQueryString = (queryObj: { [key: string]: any }) => {
  let query = "";
  for (const key in queryObj) {
    if (!query.length) {
      query += "?";
    } else {
      query += "&";
    }
    query += `${key}=${new String(queryObj[key])}`;
  }
  return query;
};

export const getTrainerDataFromLocalStorage = (key: string) => {
  const data = localStorage.getItem("trainerData");
  if (data) {
    const parsedData = JSON.parse(data);
    return parsedData?.[key];
  }
  return undefined;
};

export const setTrainerDataInLocalStorage = (
  dataToInsert: Array<{ key: string; value: string }>
) => {
  if (!dataToInsert?.length) {
    return;
  }
  const data = localStorage.getItem("trainerData");
  if (!data) {
    return;
  }
  const parsedData = JSON.parse(data);
  if (
    typeof parsedData === "object" &&
    parsedData.constructor.name === "Object"
  ) {
    for (const item of dataToInsert) {
      parsedData[item.key] = item.value.toString();
    }
    localStorage.setItem("trainerData", JSON.stringify(parsedData));
  }
};

export const isAccessAllowed = (str: string) => {
  const trainerData = trainerContextStore?.getTrainerState?.();
  const permissions = trainerData?.permissions;
  if (permissions?.length === 0) {
    return false;
  }

  return !!permissions?.find((item: any) => item?.permissionValue === str);
};

export const enumToString = (x: string) => {
  if (typeof x !== "string") {
    return "";
  }
  const str = x?.toLowerCase()?.replaceAll?.("_", " ");
  return str?.[0]?.toUpperCase?.() + str?.substring?.(1);
};

export const convert12to24 = (time12: string) => {
  if (typeof time12 !== "string" || time12.length === 0) {
    return "";
  }
  const [time, period] = time12.split(" ");
  let [hoursString, minutesString] = time.split(":");

  let hours = parseInt(hoursString);
  let minutes = parseInt(minutesString);

  if (period.toUpperCase() === "PM" && hours !== 12) {
    hours += 12;
  } else if (period.toUpperCase() === "AM" && hours === 12) {
    hours = 0;
  }

  const hoursStr = hours < 10 ? "0" + hours : hours;
  const minutesStr = minutes < 10 ? "0" + minutes : minutes;

  return `${hoursStr}:${minutesStr}`;
};

export const checkTimeOverlapping = (intervals: any) => {
  if (intervals?.length <= 1) {
    return false;
  }
  intervals.sort((a: any, b: any) =>
    compareTime(a?.availableHourStart, b?.availableHourStart) ? -1 : 1
  );
  for (let i = 1; i < intervals.length; i++) {
    if (
      new Date("1970-01-01T" + intervals[i]?.availableHourStart) <
      new Date("1970-01-01T" + intervals[i - 1]?.availableHourEnd)
    ) {
      return true;
    }
  }
  return false;
};

export const compareTime = (time1: string, time2: string) => {
  if (
    typeof time1 !== "string" ||
    typeof time2 !== "string" ||
    !time1 ||
    !time2
  ) {
    return;
  }
  const [hours1, minutes1] = time1.split(":").map(Number);
  const [hours2, minutes2] = time2.split(":").map(Number);

  if (hours1 < hours2) {
    return true;
  } else if (hours1 > hours2) {
    return false;
  } else {
    // If hours are equal, compare minutes
    if (minutes1 < minutes2) {
      return true;
    } else if (minutes1 > minutes2) {
      return false;
    } else {
      return true;
    }
  }
};

export const getDateAndDayByTimestamp = (timestamp: Number) => {
  if (!timestamp) return timestamp;
  const timeStamp = timestamp as MomentInput;
  const momentObj = moment(timeStamp);
  const dayName = momentObj.format("ddd");
  const formattedDate = momentObj.format("DD MMM");

  return {
    date: formattedDate,
    day: dayName,
  };
};

export const convertSecondsToHoursMinutes = (seconds: number) => {
  if (seconds == null || isNaN(seconds) || seconds < 0) {
    return "Invalid input";
  }

  const duration = moment.duration(seconds, "seconds");
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();

  let result = "";

  if (hours > 0) {
    result += hours === 1 ? `${hours} hour ` : `${hours} hours `;
  }
  if (minutes > 0) {
    result += minutes === 1 ? `${minutes} minute` : `${minutes} minutes`;
  }

  return result.trim();
};
